
(function () {
  if (window.licenseSelectorGlobalInitialized) return;
  window.licenseSelectorGlobalInitialized = true;

  var root = window.Shopify?.routes?.root || '/';
  var licenseCache = new Map();

  function getLicenseSelector(form) {
    var buyButtons = form.closest('buy-buttons');

    if (buyButtons) {
      var selector = buyButtons.querySelector('[data-license-selector]');
      if (selector) return selector;
    }

    var quickbuy = form.closest('.quickbuy-content');
    if (quickbuy) {
      var selector = quickbuy.querySelector('[data-license-selector]');
      if (selector) return selector;
    }

    var parent = form.parentElement;
    if (parent) {
      var selector = parent.querySelector('[data-license-selector]');
      if (selector) return selector;
    }

    return null;
  }

  function showError(selector, message) {
    var error = selector.querySelector('[data-license-error]');

    if (error) {
      error.textContent = message;
      error.hidden = false;
    }
  }

  function clearError(selector) {
    var error = selector.querySelector('[data-license-error]');

    if (error) {
      error.textContent = '';
      error.hidden = true;
    }
  }

  function updateSelection(selector) {
    selector.querySelectorAll('.license-selector__option').forEach(function (label) {
      var input = label.querySelector('input[type="radio"]');

      if (input) {
        label.classList.toggle('is-selected', input.checked);
      }
    });
  }

  function formatPrice(cents, currency) {
    try {
      return new Intl.NumberFormat(
        document.documentElement.lang || 'en',
        { style: 'currency', currency: currency }
      ).format(cents / 100);
    } catch (error) {
      return (cents / 100).toFixed(2) + ' ' + currency;
    }
  }

  function loadLicense(selector) {
    var handle = selector.dataset.licenseHandle;

    if (!handle) {
      return Promise.reject(new Error('License product handle is missing.'));
    }

    if (!licenseCache.has(handle)) {
      var request = fetch(
        root + 'products/' + encodeURIComponent(handle) + '.js'
      )
        .then(function (response) {
          if (!response.ok) {
            throw new Error('Could not load the commercial license product.');
          }

          return response.json();
        })
        .then(function (product) {
          var variant = product.variants.find(function (item) {
            return item.available;
          });

          if (!variant) {
            throw new Error('The commercial license is unavailable.');
          }

          return variant;
        })
        .catch(function (error) {
          licenseCache.delete(handle);
          throw error;
        });

      licenseCache.set(handle, request);
    }

    return licenseCache.get(handle).then(function (variant) {
      var priceElement = selector.querySelector('[data-license-price]');

    if (priceElement) {
        priceElement.classList.add('money');

        priceElement.textContent = formatPrice(
            variant.price,
            window.Shopify.currency.active
        );

        if (window.bucksCC && typeof window.bucksCC.reConvert === 'function') {
            window.bucksCC.reConvert();
        }
    }

      return variant;
    });
  }

  function initializeSelector(selector) {
    if (selector.dataset.initialized === 'true') return;

    selector.dataset.initialized = 'true';

    selector.querySelectorAll('input[type="radio"]').forEach(function (input) {
      input.addEventListener('change', function () {
        clearError(selector);
        updateSelection(selector);
      });
    });

    updateSelection(selector);

    loadLicense(selector).catch(function (error) {
      console.error('License loading failed:', error);

      var priceElement = selector.querySelector('[data-license-price]');
      if (priceElement) priceElement.textContent = 'Unavailable';
    });
  }

  function initializeSelectors(container) {
    if (!container) return;

    if (
      container.matches &&
      container.matches('[data-license-selector]')
    ) {
      initializeSelector(container);
    }

    if (container.querySelectorAll) {
      container.querySelectorAll('[data-license-selector]').forEach(
        initializeSelector
      );
    }
  }

  // Initialize selectors already on the page.
  function initializePage() {
    initializeSelectors(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializePage);
  } else {
    initializePage();
  }

  // Symmetry inserts Quick Buy content dynamically.
  document.addEventListener('on:quickbuy:after-open', function (event) {
    initializeSelectors(event.target);
    initializeSelectors(document);
  });

  // Also catch dynamically inserted selectors if Quick Buy event timing differs.
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) {
          initializeSelectors(node);
        }
      });
    });
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  // Intercept only Commercial Use submissions.
  // Personal Use continues through Symmetry's normal product form flow.
  document.addEventListener('submit', async function (event) {
    var form = event.target;

    if (!form.matches || !form.matches('form.js-product-form')) return;

    var selector = getLicenseSelector(form);
    if (!selector) return;

    initializeSelector(selector);

    var commercialInput = selector.querySelector(
      'input[type="radio"][value="commercial"]'
    );

    if (!commercialInput || !commercialInput.checked) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    clearError(selector);

    var button = form.querySelector('button[name="add"]');

    if (form.dataset.licenseSubmitting === 'true') return;
    form.dataset.licenseSubmitting = 'true';

    var originalText = button ? button.textContent : '';
    var wasDisabled = button ? button.disabled : false;

    if (button) {
      button.disabled = true;
      button.textContent = 'Adding...';
    }

    try {
      var variantInput = form.querySelector('[name="id"]');
      var quantityInput = form.querySelector('[name="quantity"]');

      var designVariantId = Number(variantInput && variantInput.value);
      var quantity = Math.max(
        1,
        parseInt(quantityInput ? quantityInput.value : '1', 10) || 1
      );

      if (!designVariantId) {
        throw new Error('Please select an available design variant.');
      }

      var license = await loadLicense(selector);

      var groupId =
        'license-' + Date.now() + '-' +
        Math.random().toString(36).slice(2, 9);

      var response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: [
            {
              id: designVariantId,
              quantity: quantity,
              properties: {
                '_License group': groupId
              }
            },
            {
              id: license.id,
              quantity: quantity,
              properties: {
                '_License group': groupId,
                'Licensed design': selector.dataset.designTitle || document.title,
                'Design variant ID': String(designVariantId),
                'License type': 'Commercial Use'
              }
            }
          ]
        })
      });

      var result = await response.json();

      if (!response.ok) {
        throw new Error(
          result.description ||
          result.message ||
          'Could not add the items to the cart.'
        );
      }

      // Refresh the theme cart drawer and cart UI.
     
      document.dispatchEvent(
        new CustomEvent('dispatch:cart-drawer:refresh')
      );

      document.dispatchEvent(
        new CustomEvent('cart:refresh')
      );

      document.dispatchEvent(
        new CustomEvent('cart:updated')
      );

      // Open the native Symmetry cart drawer
      document.dispatchEvent(
        new CustomEvent('dispatch:cart-drawer:open')
      );


      // Allow the existing global cart script to finish its own updates.
      if (button) button.textContent = 'Added!';

      // Stay on the product page / Quick Buy; do not force a redirect to /cart.
      setTimeout(function () {
        if (button) {
          button.disabled = wasDisabled;
          button.textContent = originalText;
        }

        form.dataset.licenseSubmitting = 'false';
      }, 900);

    } catch (error) {
      console.error('Commercial license error:', error);
      showError(selector, error.message || 'Could not add the license to cart.');

      if (button) {
        button.disabled = wasDisabled;
        button.textContent = originalText;
      }

      form.dataset.licenseSubmitting = 'false';
    }
  }, true);
})();









(() => {
  const SELECTOR =
    'media-gallery.media-gallery--layout-carousel-beside';

  function initThumbnailNavigation(gallery) {
    const main = gallery.querySelector('.main-image');
    const thumbnails = gallery.querySelector('carousel-slider.thumbnails');
    const slider = thumbnails?.querySelector('.slider');

    if (!main || !thumbnails || !slider) return;
    if (thumbnails.dataset.verticalNavInitialized === 'true') return;

    const grid = slider.querySelector('.slider__grid');
    if (!grid) return;

    thumbnails.dataset.verticalNavInitialized = 'true';

    const createButton = (direction, label, path) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'thumbnail-vertical-nav';
      button.dataset.direction = direction;
      button.setAttribute('aria-label', label);
      button.innerHTML = `
        <svg viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round"
          aria-hidden="true">
          <path d="${path}"></path>
        </svg>
      `;
      return button;
    };

    const up = createButton(
      'up',
      'Previous thumbnails',
      'm18 15-6-6-6 6'
    );

    const down = createButton(
      'down',
      'Next thumbnails',
      'm6 9 6 6 6-6'
    );

    thumbnails.insertBefore(up, slider);
    thumbnails.appendChild(down);

    const desktop = window.matchMedia('(min-width: 750px)');

    function updateButtons() {
      if (!desktop.matches) {
        up.hidden = true;
        down.hidden = true;
        slider.style.removeProperty('max-height');
        thumbnails.style.removeProperty('--thumbnail-viewport-height');
        return;
      }

      const maxScroll = slider.scrollHeight - slider.clientHeight;
      const canScroll = maxScroll > 2;

      up.hidden = !canScroll;
      down.hidden = !canScroll;

      up.disabled = slider.scrollTop <= 1;
      down.disabled = slider.scrollTop >= maxScroll - 1;
    }

    function syncActiveThumbnail() {
      const activeMain = main.querySelector(
        '.slider__item.is-active[data-media-id]'
      );

      if (!activeMain) return;

      const mediaId = activeMain.dataset.mediaId;
      const activeThumbnail = [...grid.querySelectorAll(
        '.slider__item[data-media-id]'
      )].find((item) =>
        item.dataset.mediaId === mediaId &&
        !item.hidden
      );

      if (!activeThumbnail) return;

      // MediaGallery already controls the active class.
      // Scroll only; do not trigger a second media selection.
      const itemTop = activeThumbnail.offsetTop;
      const itemBottom = itemTop + activeThumbnail.offsetHeight;
      const visibleTop = slider.scrollTop;
      const visibleBottom = visibleTop + slider.clientHeight;

      if (itemTop < visibleTop) {
        slider.scrollTo({ top: itemTop, behavior: 'smooth' });
      } else if (itemBottom > visibleBottom) {
        slider.scrollTo({
          top: itemBottom - slider.clientHeight,
          behavior: 'smooth'
        });
      }

      requestAnimationFrame(updateButtons);
    }

    function updateHeight() {
      if (!desktop.matches) {
        updateButtons();
        return;
      }

      const activeMain = main.querySelector(
        '.slider__item.is-active'
      );

      const mainHeight =
        activeMain?.getBoundingClientRect().height ||
        main.getBoundingClientRect().height;

      if (mainHeight > 0) {
        // Reserve room for the two navigation arrows.
        const availableHeight = Math.max(0, mainHeight);

        thumbnails.style.setProperty(
          '--thumbnail-viewport-height',
          `${availableHeight}px`
        );

        slider.style.maxHeight = `${availableHeight}px`;
      }

      requestAnimationFrame(() => {
        updateButtons();
        syncActiveThumbnail();
      });
    }

    up.addEventListener('click', () => {
      slider.scrollBy({
        top: -Math.max(100, slider.clientHeight * 0.7),
        behavior: 'smooth'
      });
    });

    down.addEventListener('click', () => {
      slider.scrollBy({
        top: Math.max(100, slider.clientHeight * 0.7),
        behavior: 'smooth'
      });
    });

    slider.addEventListener('scroll', updateButtons, {
      passive: true
    });

    // Observe responsive image/gallery size changes.
    const resizeObserver = new ResizeObserver(updateHeight);
    resizeObserver.observe(main);

    const activeObserver = new MutationObserver(() => {
      updateHeight();
    });

    activeObserver.observe(main, {
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'hidden']
    });

    activeObserver.observe(grid, {
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'hidden']
    });

    // Also catch variant changes and main-carousel selections.
    gallery.addEventListener('on:carousel-slider:select', () => {
      requestAnimationFrame(() => {
        updateHeight();
        syncActiveThumbnail();
      });
    });

    gallery.addEventListener('on:variant:change', () => {
      requestAnimationFrame(updateHeight);
    });

    desktop.addEventListener?.('change', updateHeight);

    // Wait until the theme finishes initialising the gallery.
    requestAnimationFrame(() => {
      updateHeight();
      syncActiveThumbnail();
    });

    // Recheck after responsive images load.
    main.querySelectorAll('img').forEach((img) => {
      if (!img.complete) {
        img.addEventListener('load', updateHeight, { once: true });
      }
    });
  }

  function initAll() {
    document.querySelectorAll(SELECTOR).forEach(
      initThumbnailNavigation
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Supports Shopify section re-rendering in the theme editor.
  document.addEventListener('shopify:section:load', initAll);
})();
